<section>
    <h2 class="header">{{ pageHeader }}</h2>
    <div class="progress-block">
        <h2 class="progress-header">{{ pageData.header }}</h2>
        <div class="shadow-circle">
            <div class="progress-circle"></div>
            <div *ngIf="(!user.account.isSegmentFive || !user.account.isSegmentSix || !isPlanSevenPlanSwitchResi || !isPlanSevenPlanSwitchCBM || !isCbmGemini)" class="content-holder">
                <div *ngIf="!(isSelectedPlanBtg && isCBMSegmentFive)">
                    <xm-media-image class="logo" [imageOptions]="iconOption" size="auto"></xm-media-image>
                    <div class="plan-title">{{ planName }}</div>
                    <div class="data-rate">${{ pricePerUnit }}/{{ selectedPlanData.priceUnit }}</div>
                </div>
                <div *ngIf="isCBMSegmentFive && isSelectedPlanBtg">
                    <span class="icon-content">
                        <span class="data-text">${{ pricePerUnit }}/{{ pageData.dataUnit }}</span>
                    </span>
                    <span class="data-subhead">
                        {{ pageData.description }}
                    </span>
                </div>
            </div>
            <div *ngIf="isPlanSevenPlanSwitchResi || isPlanSevenPlanSwitchCBM || isSeg6ResiUser || isCbmGemini" class="content-holder">
                <xm-media-image class="logo" [imageOptions]="iconOption" size="auto"></xm-media-image>
                <div class="plan-title">{{ planName }}</div>
                <div class="data-rate">{{ pricePerUnit }}</div>
                <cms-text class="disc-text" *ngIf="isDiscountPromotion && isCbmGemini" [originalText] = "pageData.cbmGeminiDiscountContent"></cms-text>
            </div>
        </div>
        <p class="description" *ngIf="subhead">{{ subhead }}</p>
    </div>
    <div class="buttons">
        <button class="xm-btn-primary-dark action-btn" (click)="continue()">{{ pageData.cta }}</button>
    </div>
</section>
